import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect, shallowEqual, useSelector, useDispatch } from 'react-redux';

export default function NotFoundPage() {

    return (
        <div style={styles.page}>
            <div style={styles.content}>
                <div style={styles.card}>
                    <p style={styles.code}>
                        4<span style={styles.codeAccent}>0</span>4
                    </p>
                    <p style={styles.title}>Page not found</p>
                    <p style={styles.message}>
                        The page you're looking for doesn't exist or may have been moved.
                        Double check the URL, or head back.
                    </p>
                    <button type="button" onClick={() => window.history.back()} style={styles.btn}>
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
}
const styles = {
    page: {
        margin: 0,
        background: "#f5f6fa !important",
        color: "#222",
        minHeight: "100vh",
    },
    topbar: {
        background: "#0a0a5c",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        height: 56,
    },
    brand: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontWeight: 700,
        fontSize: 20,
        letterSpacing: 1,
    },
    env: {
        color: "#f47b20",
        fontWeight: 700,
        borderLeft: "1px solid rgba(255,255,255,0.3)",
        paddingLeft: 10,
        fontSize: 16,
    },
    content: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "calc(100vh - 56px)",
        padding: "40px 20px",
    },
    card: {
        background: "#fff",
        borderRadius: 6,
        boxShadow: "0 2px 10px rgba(10,10,92,0.08)",
        padding: "56px 64px",
        textAlign: "center",
        maxWidth: 480,
    },
    code: {
        fontSize: 96,
        fontWeight: 800,
        color: "#0a0a5c",
        lineHeight: 1,
        margin: 0,
    },
    codeAccent: {
        color: "#f47b20",
    },
    title: {
        fontSize: 22,
        fontWeight: 600,
        margin: "16px 0 8px",
        color: "#1a1a2e",
    },
    message: {
        color: "#6b7280",
        fontSize: 15,
        margin: "0 0 32px",
        lineHeight: 1.5,
    },
    btn: {
        display: "inline-block",
        background: "#f47b20",
        color: "#fff",
        textDecoration: "none",
        fontWeight: 600,
        fontSize: 14,
        padding: "12px 28px",
        borderRadius: 4,
    },
};
